<template>
  <div class="main-content">
    <el-card class="preview">
      <Preview :repo_id="repoID"></Preview>
    </el-card>
  </div>
</template>

<script>
import Preview from "@/components/RepoPreview";
export default {
  name: "RepoPreview",
  components: {
    Preview
  },
  computed: {
    repoID() {
      return this.$route.params.repo_id;
    }
  }
};
</script>

<style scoped lang="scss">
.preview {
  padding-bottom: 30px;
}
</style>
